import { combineReducers } from '@reduxjs/toolkit'
import {
  accountDetailDataReducer,
  accountDetailDownloadReducer,
  accountListDataReducer,
  accountsBankingProductLoanReceiptsFiltersReducer,
  accountsBankingProductMovementsFiltersReducer,
  accountsInvestmentsFiltersReducers,
  accountsOperationsFiltersReducer,
  awmFundsDataReducer,
  awmFundsDownloadReducer,
  bankingProductLoanReceiptsDataReducer,
  bankingProductLoanReceiptsDownloadReducer,
  bankingProductMovementsDataReducer,
  bankingProductMovementsDownloadReducer,
  bankingProductsDataReducer,
  cashMovementDetailDataReducer,
  editAliasDataReducer,
  productOperationDetailDataReducer,
  productOperationsMasterListDownloadReducer,
  productOperationsMasterListReducer,
  productsByTypeDataReducer,
} from '../slices'

export const accountsReducers = combineReducers({
  detail: combineReducers({
    read: combineReducers({
      data: accountDetailDataReducer,
      download: accountDetailDownloadReducer,
      cashMovement: combineReducers({ detail: cashMovementDetailDataReducer }),
      fund: combineReducers({
        awmFunds: awmFundsDataReducer,
        awmFundsDownload: awmFundsDownloadReducer,
        operationDetail: productOperationDetailDataReducer,
      }),
      bankingProducts: bankingProductsDataReducer,
      productsByType: productsByTypeDataReducer,
    }),
    write: combineReducers({
      editAlias: combineReducers({
        data: editAliasDataReducer,
      }),
    }),
  }),
  list: combineReducers({
    data: accountListDataReducer,
  }),
  master: combineReducers({
    list: combineReducers({
      bankingProductMovements: bankingProductMovementsDataReducer,
      bankingProductMovementsDownload: bankingProductMovementsDownloadReducer,
      operations: productOperationsMasterListReducer,
      operationsDownload: productOperationsMasterListDownloadReducer,
      bankingProductLoanReceipts: bankingProductLoanReceiptsDataReducer,
      bankingProductLoanReceiptsDownload: bankingProductLoanReceiptsDownloadReducer,
    }),
    filters: combineReducers({
      bankingProduct: combineReducers({
        loanReceipts: accountsBankingProductLoanReceiptsFiltersReducer,
        movements: accountsBankingProductMovementsFiltersReducer,
      }),
      investments: accountsInvestmentsFiltersReducers,
      operations: accountsOperationsFiltersReducer,
    }),
  }),
})
